export default __webpack_public_path__ + "static/media/design-perceivable.3e08933f.png";